export enum ActivityStatus {
  PENDING = 'in progress',
  CONFIRMED = 'done',
  CANCELED = 'canceled',
}

export const ActivityStatusTitle = {
  [ActivityStatus.PENDING]: 'Pending',
  [ActivityStatus.CONFIRMED]: 'Confirmed',
  [ActivityStatus.CANCELED]: 'Canceled',
};
